const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.superadmin_users/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.superadmin_users/LIST_USERS_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
